module.exports = __webpack_public_path__ + "cc7f957fc9e62925d3e432d69f3af0bd.svg";